import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import emailjs from "@emailjs/browser";
import {
  Container,
  Grid,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Box,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Snackbar,
  Alert
} from '@mui/material';
import {
  LocationOn,
  Phone,
  Email,
  Send,
  Facebook,
  Twitter,
  LinkedIn,
  Instagram
} from '@mui/icons-material';
import GoogleMapComponent from '../../components/GoogleMapComponent';
const Contact = () => {
  const form = useRef(); // Create a reference for the form
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_ilxotpm", // Replace with your Service ID
        "template_uiaqb5k", // Replace with your Template ID
        form.current,
        "qKVZKaNQyW13NZnT0" // Replace with your Public Key
      )
      .then(
        (result) => {
          console.log("Success:", result.text);
          // setStatusMessage("Message sent successfully!");
          form.current.reset(); // Clear the form
          setSnackbar({
            open: true,
            message: 'Message sent successfully!',
            severity: 'success'
          });
          setFormData({
            name: '',
            email: '',
            phone: '',
            subject: '',
            message: ''
          })
        },
        (error) => {
          console.log("Error:", error);
          // setStatusMessage("Failed to send message. Please try again.");
          setSnackbar({
            open: true,
            message: 'Error! please try again later',
            severity: 'fail'
          });
        }
      );
    // Handle form submission logic here

  };

  const companyInfo = {
    address: 'G-26, Magnus Shopping Centre, Althan Bhimrad Canal Road , Althan Surat,395017  ',
    phone: [' +91-88491 49900'],
    email: [' jananidhi.29surat@gmail.com']
  };

  const fadeInUp = {
    initial: { opacity: 0, y: 50 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  return (
    <Container maxWidth="xl" sx={{ py: 6 }}>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Typography
          variant="h2"
          align="center"
          sx={{
            mb: 6,
            fontWeight: 'bold',
            background: 'linear-gradient(to right, #1976d2, #512da8)',

            backgroundClip: 'text',
            textFillColor: 'transparent',
            textShadow: '2px 2px 4px rgba(0,0,0,0.1)'
          }}
        >
          Get In Touch
        </Typography>
      </motion.div>

      <Grid container spacing={4}>
        {/* Contact Form Section */}
        <Grid item xs={12} md={6}>
          <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }}>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                background: "rgba(255, 255, 255, 0.9)",
                backdropFilter: "blur(10px)",
              }}
            >
              <Typography variant="h5" gutterBottom sx={{ mb: 3, color: 'linear-gradient(to right, #1976d2, #512da8)' }}>
                Send us a Message
              </Typography>
              <form ref={form} onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Name" name="user_name" variant="outlined" required />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Email" name="user_email" type="email" variant="outlined" required />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField fullWidth label="Phone" name="user_phone" variant="outlined" required />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField fullWidth label="Subject" name="subject" variant="outlined" required />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField fullWidth label="Message" name="message" multiline rows={4} variant="outlined" required />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      variant="contained"
                      size="large"
                      endIcon={<Send />}
                      sx={{
                        width: "100%",
                        height: 56,
                        background: 'linear-gradient(to right, #1976d2, #512da8)',
                        '&:hover': {
                          background: 'linear-gradient(to right, #1565c0, #4527a0)'
                        }
                      }}
                    >
                      Send Message
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Paper>
          </motion.div>
        </Grid>

        {/* Map and Contact Info Section */}
        <Grid item xs={12} md={6} mb={5}>
          <motion.div {...fadeInUp} style={{ height: '100%' }}>
            <Paper
              elevation={3}
              sx={{
                height: '100%',
                p: 3,
                background: 'rgba(255, 255, 255, 0.9)',
                backdropFilter: 'blur(10px)'
              }}
            >
              {/* Map Section */}
              <Box
                sx={{
                  width: '100%',
                  height: '300px',
                  mb: 3,
                  overflow: 'hidden',
                  borderRadius: 2
                }}
              >
                {/* <GoogleMapComponent/> */}
                <iframe
                  title="Google Map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2489.843557533107!2d72.80251721794023!3d21.142192443401026!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be051f87fe9c1c9%3A0xa08a02217e57152d!2sMagnus%20Shopping%20Mall!5e1!3m2!1sen!2sin!4v1739462186830!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  style={{ border: "0" }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </Box>

              {/* Contact Information */}
              <List>
                <ListItem>
                  <ListItemIcon>
                    <LocationOn color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Address"
                    secondary={companyInfo.address}
                  />
                </ListItem>
                {companyInfo.phone.map((phone, index) => (
                  <ListItem key={`phone-${index}`}>
                    <ListItemIcon>
                      <Phone color="primary" />
                    </ListItemIcon>
                    <ListItemText primary={phone} />
                  </ListItem>
                ))}
                {companyInfo.email.map((email, index) => (
                  <ListItem key={`email-${index}`}>
                    <ListItemIcon>
                      <Email color="primary" />
                    </ListItemIcon>
                    <ListItemText primary={email} />
                  </ListItem>
                ))}
              </List>

              {/* Social Media Links */}
               {/* Social Media Links */}
<Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
  {[
    { Icon: Facebook, link: 'https://www.facebook.com/NYCSIndia/?ref=br_rs' },
    { Icon: Twitter, link: 'https://www.youtube.com/channel/UCbZJ6pH6_XxFPdDT6CgUrBg' },
    { Icon: LinkedIn, link: 'https://www.linkedin.com/in/national-yuva-cooperative-society-limited-nycs-4541b2242/' },
    { Icon: Instagram, link: 'https://www.instagram.com/nycsindia/' }
  ].map((item, index) => ( 
    <IconButton
      key={index}
      component="a"
      href={item.link}
      target="_blank"
      rel="noopener noreferrer"
      color="primary"
      sx={{
        mx: 1,
        transition: '0.3s',
        '&:hover': {
          transform: 'translateY(-5px)',
          color: 'primary.dark'
        }
      }}
    >
      <item.Icon />
    </IconButton>
  ))}
</Box>

            </Paper>
          </motion.div>
        </Grid>
      </Grid>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Contact;